export const TERMS_URL = "https://www.after.com/legal/terms";
export const PRIVACY_URL = "https://www.after.com/legal/privacy";
